import HexSelect from './src/index.vue'

HexSelect.install = function (Vue) {
  Vue.component(HexSelect.name, HexSelect)
}
export default HexSelect



// WEBPACK FOOTER //
// ./packages/components/select/index.js